import template from './episodes.html';
import controller from './episodes.controller';
import './episodes.styl';

let episodesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default episodesComponent;



// WEBPACK FOOTER //
// ./client/app/common/admin/episodes/episodes.component.js